import React, { useState } from 'react'

// @material-ui/icons
import Tabs from '@components/Tabs'
import Axios from '@components/Axios'

import List from './components/List'
import AddEdit from './components/AddEdit'

import './styles.scss'

const Methodology = () => {
  const [run, setRun] = useState(1)
  const [list, setList] = useState([])
  const [item, setItem] = useState({})

  const onSuccessMethodologys = ({ data }) => {
    setItem({})
    setList([...data])
  }

  const updateList = () => {
    setRun(run + 1)
  }

  const tabs = [
    {
      icon: 'list',
      name: 'METHODOLOGY_TAB_LIST',
      content: <List list={list} setItem={setItem} updateList={updateList} />
    },
    {
      icon: 'add',
      name: 'METHODOLOGY_TAB_ADD',
      content: (
        <AddEdit
          item={item}
          updateList={updateList}
          close={() => setItem({})}
        />
      )
    }
  ]

  return (
    <Axios
      run={run}
      api="methodologys.blog"
      onSuccess={onSuccessMethodologys}
      others={{ page: 0, limit: 10 }}
    >
      <Axios
        api="methodologys"
        run={item._id}
        others={item._id}
        onSuccess={setItem}
      >
        <div className="Methodology">
          <Tabs headerColor="primary" tabs={tabs} />
        </div>
      </Axios>
    </Axios>
  )
}

export default Methodology
